import { graphql } from "gql.tada";

export const ThemeFragment = graphql(`
  fragment ThemeFragment on Theme {
    palette
    background
    foreground
  }
`);
